export default "__VITE_ASSET__BswJ9yni__"